import React from 'react';
import '../css/innonita.css';

const landingHTML =`<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="description" content="" />
        <meta name="author" content="" />
        <title>INNOUNITA</title>
        <!-- Favicon-->
        <link rel="icon" type="image/x-icon" href="assets/favicon.png" />
        <!-- Core theme CSS (includes Bootstrap)-->
        <link href="https://bit.ly/3Exc98U" rel="stylesheet" />
		<!-- Custom theme CSS -->
        <link href="https://bit.ly/3iWDxpV" rel="stylesheet" />
		<!-- Google Fonts CSS -->
		<link rel="preconnect" href="https://fonts.googleapis.com">
		<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
		<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
    </head>
    <body class="about-page">
        <!-- Responsive navbar-->
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <a class="navbar-brand" href="#"><img src="https://github.com/RaphaelCroitoriu/media-project-1.2/blob/main/assets/imgs/innounita-logo.png?raw=true" alt="INNOUNITA"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"><img src="https://raw.githubusercontent.com/RaphaelCroitoriu/media-project-1.2/3fc4b2f105dbe62cb8728edfbf9482245b09672e/assets/imgs/hamburger.svg"></span></button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link" aria-current="page" href="/">Home</a></li>
                    </ul>
                </div>
            </div>
        </nav>
			

		<!-- Page Content -->
		<section id="about">
			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-6 col-md-12 my-auto hero-content">
						
							<h1 class="big-title about-title-page">About Us</h1>
							<div class="about-element"></div>
							
							<p class="lead mb-4">
							The project is within the UNITA framework, a European university alliance of six university from five
							different countries (France, Italy, Portugal, Romania and Spain), with more than 160,000 students and
							15,000 staff members. 
							</p>
					</div>
					
					<div class="col-xl-6 col-md-12 my-auto hero-content">
						<section class="partners">
							<h3>Partecipating partners</h3>
						
							<div class="partner-block float-start">
								<h5>University of Turin (Lead Partner)</h5>
								<p class="text-uppercase">Italy</p>
							</div>
							
							<div class="partner-block float-end">
								<h5>University of Saragoza</h5>
								<p class="text-uppercase">Italy</p>
							</div>
							
							<div class="clearfix"></div>
							
							<div class="partner-block float-start">
								<h5>University of Beira Interior</h5>
								<p class="text-uppercase">Portugal</p>
							</div>
							
							<div class="partner-block float-end">
								<h5>University of Pau and the Adour Region</h5>
								<p class="text-uppercase">France</p>
							</div>
							
							<div class="clearfix"></div>
							
							<div class="partner-block float-start">
								<h5>Savoy Mont Blanc University</h5>
								<p class="text-uppercase">France</p>
							</div>
							
							<div class="partner-block float-end">
								<h5>West University of Timisoara</h5>
								<p class="text-uppercase">Romania</p>
							</div>
							
							<div class="clearfix"></div>
						</section>
					</div>
				</div>
        	</div>

		</section>
		
		
        <!-- Bootstrap core JS-->
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>
        <!-- Core theme JS-->
        <script src="https://bit.ly/3EWXWnf"></script>
    </body>
</html>
`

const About = () => {
    return(
        <div><div dangerouslySetInnerHTML={{ __html: landingHTML }} />;</div>
    );
};

export default About;
